export default "__VITE_ASSET__BcvZvHhx__"